import * as types from './types';
import { createAction } from '../../models/redux/CreateAction';

export const setLogin = payload => {
  return createAction(types.AUTH_USER_LOGIN_REQUEST, payload);
};

export const getDriver = () => {
  return createAction(types.AUTH_USER_DRIVER_REQUEST);
};

export const setUser = payload => {
  return createAction(types.AUTH_USER_LOGIN_RECEIVE, payload);
};

export const setLoginError = error => {
  return createAction(types.AUTH_USER_LOGIN_ERROR, error);
};

export const setUserLogout = () => {
  return {
    type: types.AUTH_USER_LOGOUT_REQUEST
  };
};

export const clearLoginError = () => {
  return {
    type: types.AUTH_USER_CLEAR_LOGIN_ERROR
  };
};

export const setUserRoles = (roles: string[]) => {
  return {
    type: types.AUTH_USER_SET_ROLES,
    payload: roles
  };
};
